import { useTranslation } from "react-i18next";
import { Chip } from "./chip";

export interface FilterChipSpec {
  id: string;
  label: string;
}

export interface FilterChipBarProps {
  chips: FilterChipSpec[];
  onRemove: (id: string) => void;
  onAdd: () => void;
}

export function FilterChipBar({ chips, onRemove, onAdd }: FilterChipBarProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2">
      {chips.map((c) => (
        <Chip key={c.id} removable onRemove={() => onRemove(c.id)}>
          {c.label}
        </Chip>
      ))}
      <Chip variant="dashed-plus" onClick={onAdd}>
        {t("common.filter-chip.add.label")}
      </Chip>
    </div>
  );
}
